import React from 'react';
import PropTypes from 'prop-types';

/** An inline svg component. */
const VisaCard = ({
  size = 16,
  height = 30,
  width = 30,
  svgRef,
  title,
  style = {},
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 30 30"
      height={height || size}
      width={width || size}
      ref={svgRef}
      aria-labelledby={title ? title : undefined}
      style={{ pointerEvents: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      {title ? <title id={title}>{title}</title> : null}
      <path
        id="Fill 4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.25 11.3906L12.5625 19.2656H10.5L12.1875 11.3906H14.25ZM22.8281 16.5L23.9062 13.5469L24.5156 16.5H22.8281ZM25.125 19.2656H27L25.3594 11.3906H23.625C23.25 11.3906 22.9219 11.625 22.7344 11.9531L19.6875 19.2656H21.8438L22.2656 18.0938H24.8906L25.125 19.2656ZM19.7812 16.6875C19.7812 14.625 16.9219 14.4844 16.9219 13.5469C16.9219 13.2656 17.2031 12.9844 17.7656 12.8906C18.0469 12.8438 18.8438 12.8438 19.7812 13.2656L20.1562 11.5781C19.6875 11.3906 19.0312 11.25 18.2344 11.25C16.2188 11.25 14.8125 12.3281 14.7656 13.875C14.7656 15 15.7969 15.6562 16.5469 16.0312C17.3438 16.4062 17.625 16.6875 17.625 17.0156C17.625 17.5312 16.9688 17.7656 16.4062 17.7656C15.375 17.7656 14.7656 17.4844 14.2969 17.25L13.9688 18.9844C14.4375 19.2188 15.3281 19.4062 16.2188 19.4062C18.375 19.4062 19.7812 18.3281 19.7812 16.6875ZM11.3438 11.3906L8.01562 19.2656H5.85938L4.26562 12.9844C4.17188 12.6094 4.07812 12.4688 3.79688 12.2812C3.32812 12 2.48438 11.7656 1.78125 11.625V11.3906H5.25C5.67188 11.3906 6.09375 11.6719 6.1875 12.1875L7.03125 16.7344L9.14062 11.3438H11.3438V11.3906Z"
        fill="#1634CC"
      />
    </svg>
  );
};

VisaCard.propTypes = {
  /** Optional class name to apply to `svg` element. */
  className: PropTypes.string,
  /** Height of `svg`. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gets applied to both `height` and `width` of `svg`. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Use if you want to get a `ref` to the `svg` element. */
  svgRef: PropTypes.func,
  /** For accessability. Allows icons in buttons etc. to be read by screen readers. */
  title: PropTypes.string,
  /** Width of `svg`. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { VisaCard };
